/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'COMPOSE_EXPERIENCE_URL',
  PUT: 'UPDATE_COMPOSE_EXPERIENCE_URL',
  DELETE: 'DELETE_COMPOSE_EXPERIENCE_URL',
  RESET: 'RESET_COMPOSE_EXPERIENCE_URL',
  RELOAD: 'RELOAD_COMPOSE_EXPERIENCE_URL',
};

export const getDraftId = () => (`composeExperienceUrl-draft${new Date().valueOf()}`);

export const composeExperienceUrlsReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      const id = action.payload.id ? action.payload.id : getDraftId();
      return [
        ...state,
        { ...action.payload, id },
      ];
    case types.PUT:
      return state.map((child) => (child.id == action.payload.id ? action.payload : child));
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.indexOf(action.item);
      newValues.splice(index, 1);
      return newValues;
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
